/**
 * Utilitaires pour manipuler le HTML
 * Fonctions extraites du module content-structure-services.js
 */

/**
 * Décode les entités HTML (remplace parse_entities.parseEntities)
 * @param {string} html - Texte HTML contenant des entités HTML
 * @returns {string} - Texte avec entités HTML décodées
 */
function decodeHTMLEntities(html) {
    const textarea = document.createElement('textarea');
    textarea.innerHTML = html;
    return textarea.value;
}

// Exportation des fonctions
export { decodeHTMLEntities };
